import { Navigate, type RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';
import { payrollRoutes as pensionRoutes } from './pensions/routes';

// Payroll (Phase H). Owned by the payroll module; other Phase H tracks add their pages to the
// children below and a tab to payroll-layout.tsx.
export const routes: RouteObject[] = [
  {
    path: 'payroll',
    lazy: page(() => import('./payroll-layout'), (m) => m.PayrollLayout),
    children: [
      { index: true, element: <Navigate to="runs" replace /> },
      // H-F pay runs
      { path: 'runs', lazy: page(() => import('./payrun/runs-page'), (m) => m.PayRunsPage) },
      { path: 'runs/:id', lazy: page(() => import('./payrun/run-detail-page'), (m) => m.PayRunDetailPage) },
      { path: 'leavers', lazy: page(() => import('./payrun/leavers-page'), (m) => m.LeaversPage) },
      { path: 'corrections', lazy: page(() => import('./payrun/corrections-page'), (m) => m.CorrectionsPage) },
      // H-B records
      { path: 'employees', lazy: page(() => import('./employees-page'), (m) => m.PayrollEmployeesPage) },
      { path: 'inputs', lazy: page(() => import('./inputs-page'), (m) => m.PayInputsPage) },
      { path: 'schedules', lazy: page(() => import('./schedules-page'), (m) => m.PaySchedulesPage) },
      { path: 'schemes', lazy: page(() => import('./employers-page'), (m) => m.PayeSchemesPage) },
      { path: 'elements', lazy: page(() => import('./elements-page'), (m) => m.PayElementsPage) },
      { path: 'legal-holds', lazy: page(() => import('./legal-holds-page'), (m) => m.LegalHoldsPage) },
      // H-G outputs
      { path: 'outputs', lazy: page(() => import('./outputs/runs-page'), (m) => m.PayRunsPage) },
      { path: 'outputs/:id', lazy: page(() => import('./outputs/run-page'), (m) => m.PayRunPage) },
      { path: 'year-end', lazy: page(() => import('./outputs/year-end-page'), (m) => m.YearEndPage) },
      { path: 'payment-settings', lazy: page(() => import('./outputs/payment-settings-page'), (m) => m.PaymentSettingsPage) },
      // H-H benefits in kind
      { path: 'benefits', lazy: page(() => import('./benefits/benefits-page'), (m) => m.BenefitsInKindPage) },
      // P2-4 (BUG-31, A10): Pensions (was Settings → Pensions) and Statutory pay (was HR → Statutory
      // pay). The statutory pay pages stay in the hr module; /hr/statutory-pay redirects here.
      ...pensionRoutes,
      { path: 'statutory-pay', lazy: page(() => import('../hr/statutory/statutory-pay-page'), (m) => m.StatutoryPayPage) },
      { path: 'statutory-pay/:id', lazy: page(() => import('../hr/statutory/case-page'), (m) => m.StatutoryCasePage) },
      // P1-F1 HMRC (RTI). Notifications link to rti/notices and rti/submissions/:id.
      {
        path: 'rti',
        lazy: page(() => import('./rti/rti-layout'), (m) => m.RtiLayout),
        children: [
          { index: true, element: <Navigate to="schemes" replace /> },
          { path: 'schemes', lazy: page(() => import('./rti/schemes-page'), (m) => m.RtiSchemesPage) },
          { path: 'submissions', lazy: page(() => import('./rti/submissions-page'), (m) => m.RtiSubmissionsPage) },
          { path: 'submissions/:id', lazy: page(() => import('./rti/submissions-page'), (m) => m.RtiSubmissionPage) },
          { path: 'eps', lazy: page(() => import('./rti/eps-page'), (m) => m.RtiEpsPage) },
          { path: 'nvr', lazy: page(() => import('./rti/nvr-page'), (m) => m.RtiNvrPage) },
          // One route, so opening a notice keeps the list's filters.
          { path: 'notices/:id?', lazy: page(() => import('./rti/notices-page'), (m) => m.RtiNoticesPage) },
        ],
      },
    ],
  },
];

export const orgRoutes: RouteObject[] = [];
